import requests from '@/utils/requests'

const getUsers = params => requests({ url: '/users', method: 'get', params })
const updateUserStatus = (id, status) => requests({ url: `/users/${id}/status`, method: 'put', data: { status } })
const giftVip = (id, remark) => requests({ url: `/users/${id}/gift-vip`, method: 'post', data: { remark } })
const getVipRecords = params => requests({ url: '/vip-records', method: 'get', params })
const getUserLoginLogs = params => requests({ url: '/user-login-logs', method: 'get', params })
const getFeedbacks = params => requests({ url: '/feedbacks', method: 'get', params })
const getFeedback = id => requests({ url: `/feedbacks/${id}`, method: 'get' })
const createFeedback = data => requests({ url: '/feedbacks', method: 'post', data })
const updateFeedback = (id, data) => requests({ url: `/feedbacks/${id}`, method: 'put', data })
const deleteFeedback = id => requests({ url: `/feedbacks/${id}`, method: 'delete' })
const getConnections = params => requests({ url: '/connections', method: 'get', params })
const getConnection = (id, params) => requests({ url: `/connections/${id}`, method: 'get', params })
const getDreams = params => requests({ url: '/dreams', method: 'get', params })
const getDream = id => requests({ url: `/dreams/${id}`, method: 'get' })
const getUserTimeline = (id, params) => requests({ url: `/users/${id}/timeline`, method: 'get', params })
const getUserMessages = (id, params) => requests({ url: `/users/${id}/messages`, method: 'get', params })

const getAdmins = params => requests({ url: '/admins', method: 'get', params })
const createAdmin = data => requests({ url: '/admins', method: 'post', data })
const updateAdmin = (id, data) => requests({ url: `/admins/${id}`, method: 'put', data })
const deleteAdmin = id => requests({ url: `/admins/${id}`, method: 'delete' })
const getAdminLoginLogs = params => requests({ url: '/admin-login-logs', method: 'get', params })
const getMiniConfigs = params => requests({ url: '/mini-configs', method: 'get', params })
const getMiniConfig = id => requests({ url: `/mini-configs/${id}`, method: 'get' })
const createMiniConfig = data => requests({ url: '/mini-configs', method: 'post', data })
const updateMiniConfig = (id, data) => requests({ url: `/mini-configs/${id}`, method: 'put', data })
const deleteMiniConfig = id => requests({ url: `/mini-configs/${id}`, method: 'delete' })
const getSettings = () => requests({ url: '/settings', method: 'get' })
const updateVipFee = vipFee => requests({ url: '/settings/vip-fee', method: 'put', data: { vipFee } })
const updateVipEnabled = vipEnabled => requests({ url: '/settings/vip-enabled', method: 'put', data: { vipEnabled } })
const createVipProduct = data => requests({ url: '/settings/vip-products', method: 'post', data })
const activateVipProduct = id => requests({ url: `/settings/vip-products/${id}/active`, method: 'put' })

export default {
	getUsers,
	updateUserStatus,
	giftVip,
	getVipRecords,
	getUserLoginLogs,
	getFeedbacks,
	getFeedback,
	createFeedback,
	updateFeedback,
	deleteFeedback,
	getConnections,
	getConnection,
	getDreams,
	getDream,
	getUserTimeline,
	getUserMessages,
	getAdmins,
	createAdmin,
	updateAdmin,
	deleteAdmin,
	getAdminLoginLogs,
	getMiniConfigs,
	getMiniConfig,
	createMiniConfig,
	updateMiniConfig,
	deleteMiniConfig,
	getSettings,
	updateVipFee,
	updateVipEnabled,
	createVipProduct,
	activateVipProduct
}
